import React, { useState } from "react";
import { api } from "../lib/api";

const STATUSES = ["confirmed", "building", "shipped", "delivered"];

export const OrderStatusControl = ({ order, onUpdated }) => {
  const [status, setStatus] = useState(order.order_status || "confirmed");
  const [awb, setAwb] = useState(order.tracking_number || "");
  const [courier, setCourier] = useState(order.courier || "");
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);

  const save = async () => {
    setSaving(true);
    setSaved(false);
    try {
      await api.patch(`/admin/orders/${order.session_id}/status`, {
        order_status: status,
        tracking_number: awb,
        courier,
      });
      setSaved(true);
      onUpdated?.(order.session_id, { order_status: status, tracking_number: awb, courier });
      setTimeout(() => setSaved(false), 2000);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="mt-3 pt-3 border-t border-white/10 flex flex-wrap items-center gap-2">
      <select
        value={status}
        onChange={(e) => setStatus(e.target.value)}
        className="bg-black border border-white/15 px-2 py-1.5 text-xs af-mono uppercase tracking-widest focus:outline-none focus:border-[#FF2800]"
        data-testid={`order-status-select-${order.session_id}`}
      >
        {STATUSES.map((s) => (
          <option key={s} value={s}>
            {s}
          </option>
        ))}
      </select>
      {(status === "shipped" || status === "delivered") && (
        <>
          <input
            value={courier}
            onChange={(e) => setCourier(e.target.value)}
            placeholder="Courier (e.g. Delhivery)"
            className="bg-black border border-white/15 px-2 py-1.5 text-xs w-36 focus:outline-none focus:border-[#FF2800] placeholder:text-zinc-700"
            data-testid={`order-courier-input-${order.session_id}`}
          />
          <input
            value={awb}
            onChange={(e) => setAwb(e.target.value)}
            placeholder="Tracking / AWB #"
            className="bg-black border border-white/15 px-2 py-1.5 text-xs w-36 focus:outline-none focus:border-[#FF2800] placeholder:text-zinc-700"
            data-testid={`order-awb-input-${order.session_id}`}
          />
        </>
      )}
      <button
        type="button"
        onClick={save}
        disabled={saving}
        className="bg-[#FF2800] hover:bg-[#CC2000] disabled:opacity-50 px-3 py-1.5 text-xs af-mono uppercase tracking-widest transition-colors"
        data-testid={`order-status-save-${order.session_id}`}
      >
        {saving ? "Saving…" : saved ? "Saved ✓" : "Update"}
      </button>
    </div>
  );
};
